import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, SectionTitle } from "@/components/shared/primitives";
import { ROLE_LABELS } from "@/lib/auth";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function RolesAccess() {
  const qc = useQueryClient();
  const { data: members } = useQuery({ queryKey: ["members-all"], queryFn: () => api.get("/members", { limit: 500 }) });

  const setRole = async (memberId, role) => {
    try {
      await api.patch(`/members/${memberId}/role`, { role });
      toast.success("Role updated.");
      qc.invalidateQueries();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <Card className="p-5">
      <SectionTitle className="mb-1">Roles and access</SectionTitle>
      <p className="text-[13px] text-nb-ink2 mb-4">Assign Admin, IT Admin or Team Lead. Every permission is enforced on the server.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-[14px]">
          <thead><tr className="text-[13px] text-nb-ink2 text-left border-b border-nb-border"><th className="py-2 font-medium">Name</th><th className="py-2 font-medium">Email</th><th className="py-2 font-medium">Role</th></tr></thead>
          <tbody>
            {(members?.data || []).map((m) => (
              <tr key={m.member_id} className="border-b border-nb-border last:border-0">
                <td className="py-2.5 text-nb-ink">{m.name}</td>
                <td className="py-2.5 text-nb-ink2">{m.email || "-"}</td>
                <td className="py-2.5">
                  <Select value={m.role || "member"} onValueChange={(v) => setRole(m.member_id, v)}>
                    <SelectTrigger className="h-9 w-[200px]" data-testid={`role-select-${m.member_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{Object.entries(ROLE_LABELS).map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
